

































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import CashflowAnalysis from '@/webreport/components/CashflowAnalysis.vue';

@Component({components: {CashflowAnalysis}})
export default class CardCashFlowAnalysis extends CompanyMixin {
}
